var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.messages),function(message,index){return _c('div',{key:index},[(message.sent_by_me)?_c('ChatMessageByMe',{attrs:{"message":message}}):_c('ChatMessage',{attrs:{"message":message}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }